export default "__VITE_ASSET__CwpPiesG__"